// HJ brand logo at a given size, with the violet glow used across the redesign.
// `size` is the square side in px. radius/fontSize are accepted for backward
// compatibility with existing call sites but no longer used (the logo is an SVG).
import HjLogo from "../assets/hjLogo";

interface LogoTileProps {
  size?: number;
  radius?: number;
  fontSize?: number;
  className?: string;
  shadow?: "sm" | "lg";
}

export default function LogoTile({ size = 46, className = "", shadow = "sm" }: LogoTileProps) {
  return (
    <div
      className={`shrink-0 leading-none ${className}`}
      style={{
        width: size,
        height: size,
        filter:
          shadow === "lg"
            ? "drop-shadow(0 16px 40px rgba(91,52,232,0.5))"
            : "drop-shadow(0 6px 16px rgba(124,92,252,0.4))",
      }}
    >
      <HjLogo size={size} />
    </div>
  );
}
